import React from 'react'
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link, Typography, makeStyles } from '@material-ui/core'
import { sanitizeUrl } from '../utils/urlSanitizer'

const useStyles = makeStyles((theme) => ({
  richTable: {
    width: '100%',
    borderStyle: 'solid',
    borderColor: '#000',
    borderWidth: '0 1px 1px 0',
    borderCollapse: 'collapse',
  },
  richHeading: {
    padding: theme.spacing(1.5, 2.5),
    textAlign: 'start',
    borderStyle: 'solid',
    borderWidth: '1px 0 0 1px',
    fontWeight: 500,
    borderCollapse: 'collapse',
  },
  richData: {
    padding: theme.spacing(1.5, 2.5),
    borderStyle: 'solid',
    borderWidth: '1px 0 0 1px',
    borderCollapse: 'collapse',
  },
}))

const renderHeading = (variant, children) => (
  <Typography variant={variant}>{children}</Typography>
)
/* eslint-disable react/display-name */
const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => (
      <Typography variant="inherit" style={{ fontWeight: 500 }}>
        {text}
      </Typography>
    ),
    [MARKS.ITALIC]: (text) => (
      <Typography variant="inherit" style={{ fontStyle: 'italic' }}>
        {text}
      </Typography>
    ),
    [MARKS.CODE]: (text) => <Typography component="pre">{text}</Typography>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <Typography variant="inherit" paragraph>
        {children}
      </Typography>
    ),
    [BLOCKS.HEADING_1]: (_, children) => renderHeading('h1', children),
    [BLOCKS.HEADING_2]: (_, children) => renderHeading('h2', children),
    [BLOCKS.HEADING_3]: (_, children) => renderHeading('h3', children),
    [BLOCKS.HEADING_4]: (_, children) => renderHeading('h4', children),
    [BLOCKS.HEADING_5]: (_, children) => renderHeading('h5', children),
    [BLOCKS.HEADING_6]: (_, children) => renderHeading('h6', children),
    [INLINES.HYPERLINK]: (node, children) => {
      const sanitizedUrl = sanitizeUrl(
        (node && node.data && node.data.uri) || '#',
      )

      return (
        <Link
          href={sanitizedUrl}
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
        >
          {children}
        </Link>
      )
    },
    table: (_, children) => {
      const styles = useStyles()

      return (
        <table className={styles.richTable}>
          <tbody>{children}</tbody>
        </table>
      )
    },
    'table-header-cell': (_, children) => {
      const styles = useStyles()
      return <th className={styles.richHeading}>{children}</th>
    },
    'table-row': (_, children) => {
      return <tr>{children}</tr>
    },
    'table-cell': (_, children) => {
      const styles = useStyles()

      return <td className={styles.richData}>{children}</td>
    },
  },
}
/* eslint-enable react/display-name */
const RichText = ({ document, variant = 'body2', className }) => (
  // To be able to pass on variant & className to underlying text
  <Typography variant={variant} component="div" className={className}>
    {documentToReactComponents(document, options)}
  </Typography>
)
export default RichText
